import { render } from "./PackageUsage.vue?vue&type=template&id=f1254d6a&scoped=true"
import script from "./PackageUsage.vue?vue&type=script&lang=js"
export * from "./PackageUsage.vue?vue&type=script&lang=js"

import "./PackageUsage.vue?vue&type=style&index=0&id=f1254d6a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1254d6a"]])

export default __exports__